

export class DeviceStatusInput implements IDeviceStatusInput {
    /** The auto-generated id of the device master */
    deviceId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IDeviceStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceStatusInput {
    /** The auto-generated id of the device master */
    deviceId: number;
    /** The updated status */
    status: number;
}

